// customerHotelApi.js
import axios from "axios";
import querystring from "querystring";
import { getUserData, configFetch } from "./config";

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  CustomerHotelIndex: `${HOSTNAME}/cushotel/index`,
  CustomerHotelAdd: `${HOSTNAME}/cushotel/add`,
  CustomerHotelUpdate: `${HOSTNAME}/cushotel/update`,
  CustomerHotelDelete: `${HOSTNAME}/cushotel/delete`,
};

export const repairCustomerScope = async () => {
  const response = await axios(configFetch(`${HOSTNAME}/cushotel/repair-scope`, 'post', {}, true, {
    Authorization: `Bearer ${getUserData().token}`,
  }));
  return response.data;
};
export const resyncCustomer = async (id) => {
  const response = await axios({ ...configFetch(`${HOSTNAME}/cushotel/resync`, 'post', { id }, true, {
    Authorization: `Bearer ${getUserData().token}`,
  }), timeout: 60000 });
  return response.data;
};

export const fetchCustomerSyncStatus = async () => {
  const userData = getUserData();
  const response = await axios({ ...configFetch(`${HOSTNAME}/cushotel/sync-status`, "get", null, true, {
    Authorization: `Bearer ${userData.token}`,
  }), timeout: 120000 });
  return response.data;
};

export const refreshCustomerSyncStatus = async () => {
  const userData = getUserData();
  const response = await axios({ ...configFetch(`${HOSTNAME}/cushotel/sync-status/refresh`, "post", {}, true, {
    Authorization: `Bearer ${userData.token}`,
  }), timeout: 120000 });
  return response.data;
};

// Function to fetch customer hotels
export const fetchCustomerHotels = async (params) => {
  try {
    const userData = getUserData();
    const url = `${API_SERVICES.CustomerHotelIndex}?${querystring.stringify(params)}`;
    const response = await axios(configFetch(url, "get", null, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error fetching customer hotels:", error.message);
    throw error;
  }
};

// Function to add a customer hotel
export const addCustomerHotel = async (data) => {
  try {
    const userData = getUserData();
    const response = await axios(configFetch(API_SERVICES.CustomerHotelAdd, "post", data, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error adding customer hotel:", error.message);
    throw error;
  }
};

// Function to update a customer hotel
export const updateCustomerHotel = async (data) => {
  try {
    const userData = getUserData();
    const response = await axios(configFetch(API_SERVICES.CustomerHotelUpdate, "put", data, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
    return response.data;
  } catch (error) {
    console.error("Error updating customer hotel:", error.message);
    throw error;
  }
};

// Function to delete a customer hotel
export const deleteCustomerHotel = async (id) => {
  try {
    const userData = getUserData();
    await axios(configFetch(`${API_SERVICES.CustomerHotelDelete}`, "delete", id, true, {
      Authorization: `Bearer ${userData.token}`,
    }));
  } catch (error) {
    console.error("Error deleting customer hotel:", error.message);
    throw error;
  }
};
